import React, { useState, useEffect, useRef } from 'react'
import Skeleton from 'react-loading-skeleton';
import { Link } from 'react-router-dom';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import Button from './Button';
import { BlocksRenderer } from '@strapi/blocks-react-renderer';

const TimelineSlider = ({ tabs }) => {

    const [slidesToShow, setSlidesToShow] = useState(3);

    const [current, setCurrent] = useState(0);

    const [currentSlide, setCurrentSlide] = useState(0);

    const DOT_GAP = 240;

    useEffect(() => {
        const handleResize = () => {
            const width = window.innerWidth;

            if (width <= 600) {
                setSlidesToShow(1);
                setCurrent(0);
            } else if (width <= 1024) {
                setSlidesToShow(1.25);
                setCurrent(0);
            } else {
                setSlidesToShow(1.25);
                setCurrent(0);
            }

            // setCurrent((prev)=>{return prev + 1});
        };

        // run on mount
        handleResize();

        // listen to resize
        window.addEventListener("resize", handleResize);

        // cleanup
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        const equalHeight = () => {
            const slides = document.querySelectorAll(
                ".slick-slide"
            );

            console.log('here all', slides)

            let maxHeight = 0;

            // reset height first
            slides.forEach((slide) => {
                slide.style.height = "auto";
            });

            // find max height
            slides.forEach((slide) => {
                if (slide.offsetHeight > maxHeight) {
                    maxHeight = slide.offsetHeight;
                }
            });

            // apply max height to all
            slides.forEach((slide) => {
                slide.style.height = `${maxHeight}px`;
            });
        };

        // run after slider render
        setTimeout(() => {
            equalHeight();
        }, 300);

        // on resize
        window.addEventListener("resize", equalHeight);

        return () => {
            window.removeEventListener("resize", equalHeight);
        };
    }, []);

    const slides = [1, 2, 3, 4, 5, 6];

    const settings = {
        dots: false,
        arrows: true,
        infinite: false,
        speed: 500,
        slidesToShow: slidesToShow,   // default (desktop)
        slidesToScroll: 1,
        cssEase: "linear",
        margin: 5,
        beforeChange: (oldIndex, newIndex) => {
            setCurrentSlide(Math.round(newIndex));
        },
        // responsive: [
        //     {
        //         breakpoint: 1024, // tablet
        //         settings: {
        //             slidesToShow: 2
        //         }
        //     },
        //     {
        //         breakpoint: 768, // mobile
        //         settings: {
        //             slidesToShow: 1
        //         }
        //     }
        // ]
    };
    const total = tabs.length;
    const progressWidth = currentSlide * DOT_GAP;

    useEffect(() => {

        console.log('testtt', progressWidth, currentSlide, DOT_GAP)

    }, [progressWidth, currentSlide])

    useEffect(() => {
        const equalHeight = () => {
            // 👉 H4 elements
            const headings = document.querySelectorAll(
                ".dokumente_slider .item_inner h4"
            );

            let maxH4 = 0;
            headings.forEach((el) => {
                el.style.height = "auto";
                maxH4 = Math.max(maxH4, el.offsetHeight);
            });
            headings.forEach((el) => {
                el.style.height = maxH4 + "px";
            });

            // 👉 P elements
            const paragraphs = document.querySelectorAll(
                ".dokumente_slider .item_inner p"
            );

            let maxP = 0;
            paragraphs.forEach((el) => {
                el.style.height = "auto";
                maxP = Math.max(maxP, el.offsetHeight);
            });
            paragraphs.forEach((el) => {
                el.style.height = maxP + "px";
            });
        };

        // run on load
        setTimeout(equalHeight, 300);
        // run on resize
        window.addEventListener("resize", equalHeight);
        return () => {
            window.removeEventListener("resize", equalHeight);
        };
    }, []);

    const truncateBlocks = (blocks, maxLength = 120) => {
        if (!blocks) return "";

        let text = "";

        for (let block of blocks) {
            if (block.children) {
                for (let child of block.children) {
                    text += child.text;

                    if (text.length >= maxLength) {
                        return text.slice(0, maxLength) + "...";
                    }
                }
            }
        }

        return text;
    };

    const sliderRef = useRef(null);

    const isFirst = currentSlide === 0;
    const isLast = currentSlide === tabs.length - 1;

    const handleNext = () => {
        sliderRef.current?.slickNext();
    };

    const handlePrev = () => {
        sliderRef.current?.slickPrev();
    };

    const goToSlide = (index) => {
        sliderRef.current?.slickGoTo(index);
    };

    return (
        <div className='slider_wrapper slider-arrow-bg slick-slide-margin timeline-slider mt-4'>
            <Slider ref={sliderRef} {...settings}>
                {tabs?.map((tab, index) => (
                    <div className='slider_slide_item'>
                        <div className={`row h-100 timeline-row ${index <= currentSlide ? "active" : ""}`}>
                            <div className="col-lg-6 pe-lg-0">
                                <img src={`https://backend.bgzurlinden.ch${tab?.Bild[0]?.url}`} alt='#' />
                            </div>
                            <div className="col-lg-6 ps-lg-0">
                                <div className="timeline-inner-content">
                                    <h2 className="text-pink">{tab?.Sub_Titel}</h2>
                                    <h3 className='text-black top-line fw-500'>{tab?.Titel}</h3>

                                    {tab?.Text && <BlocksRenderer content={tab?.Text} />}

                                    {tab?.Komponente && <Button component={tab?.Komponente} pdf={tab?.PDF} buttons={tab?.Button} />}

                                    <div className="tab-change-button d-flex d-md-none gap-3 mt-4">
                                        <button className="nav_btns_custom button_prev" onClick={handlePrev} disabled={isFirst}><img src="images/white-arrow-prev.svg" /></button>
                                        <button className="nav_btns_custom button_next" onClick={handleNext} disabled={isLast}><img src="images/white-arrow-next.svg" /></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}

            </Slider>
            {/* Top Section */}
            {/* Timeline Progress */}
            <div
                className="timeline-progress-wrapper d-none d-lg-block"
                style={{ width: `${(tabs.length - 1) * DOT_GAP}px`, transform: `translateX(-${currentSlide * DOT_GAP / 3}px)` }}
            >
                {/* Gray Line */}
                <div className="timeline-line"></div>

                {/* Pink Progress */}
                <div
                    className="timeline-line-active"
                    style={{
                        width: `${progressWidth}px`,
                    }}
                ></div>

                {tabs?.map((tab, index) => (
                    <div
                        key={index}
                        className={`timeline-outer-dot ${currentSlide >= index ? "active" : ""
                            }`}
                        style={{
                            left: `${index * DOT_GAP}px`,
                            backgroundColor: '#fff',
                            width: '50px',
                            height: '50px',
                            borderRadius: '50%',
                        }}
                    >
                        <span onClick={() => goToSlide(index)} >{tab?.Sub_Titel}</span>
                    </div>
                ))}

                {/* Dots */}
                {tabs?.map((tab, index) => (
                    <div
                        key={`dot-${index}`}
                        className={`timeline-dot ${currentSlide >= index ? "active" : ""
                            }`}
                        onClick={() => goToSlide(index)}
                        style={{
                            left: `${index * DOT_GAP}px`,
                            cursor: "pointer",
                        }}
                    />
                ))}
            </div>
        </div>
    )
}

export default TimelineSlider